module.exports = {"Administración de adicionales":"Administración de tipos de adicionales","Listado de adicionales":"Listado de tipos de adicionales","Nombre":"Nombre","Estado":"Estado","Ver adicional":"Ver tipo de adicional","Editar adicional":"Editar tipo de adicional","Nuevo adicional":"Definición de tipo de adicional","Monto":"Monto","Tipo Adicional":"Tipo Adicional"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/adicionales/es.json
// module id = 1129
// module chunks = 0